export default "__VITE_ASSET__eb5748ed__"